import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';

export namespace SymbolGroupsAction {
  const actionCreator = actionCreatorFactory('SymbolGroups');

  export const load = actionCreator.async<void, string[], IApiErrorParams>('LOAD');
  export const select = actionCreator<{ symbolGroup: string }>('SELECT');
  export const toggleSelect = actionCreator<{ symbolGroup: string; isMulti?: boolean }>('TOGGLE_SELECT');
  export const clearSelect = actionCreator('CLEAR_SELECT');

  export const destroy = actionCreator('DESTROY');
}
